module.exports = __webpack_public_path__ + "8ae84166e57d5e257b50dc27ef4517b4.svg";